export default "__VITE_ASSET__n8H55ssZ__"